import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

const AdministrationIcon = () => {
  return (
    <span className="administration-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <g id="hand_back">
          <path
            className="cls-1"
            d="M37.23,36.38h-.02l-2.27-.03,5.88-3.63h0l3.87-2.39c.32-.19.68-.29,1.05-.3.79-.02,1.53.38,1.94,1.06.63,1.04.31,2.41-.73,3.05l-5.99,3.7c-.31-.34-.71-.62-1.2-.85-1.16-.55-2.48-.6-2.53-.6Z"
          />
        </g>
        <g id="bg">
          <path
            className="cls-4"
            d="M44.4,3.1v33.26c0,.82-.77,1.48-1.72,1.48H5c-.95,0-1.72-.66-1.72-1.48V3.1c0-1.71,1.19-3.1,2.65-3.1h35.82c1.46,0,2.65,1.39,2.65,3.1Z"
          />
        </g>
        <g id="hand_front">
          <path
            className="cls-1"
            d="M3.26,33.76c3.61-.87,7.44-2.09,11.81-.59,1.33.46,2.95,1.3,4.43,2.15,1.79,1.02,3.81,1.59,5.87,1.62l11.68.15s1.18.04,2.21.52c.4.19.78.44,1.05.79.96,1.22.14,2.97.14,2.97,0,0-.17.23-.85.29-.68.06-4.95-.01-4.95-.01h0s-10.2.28-10.2.28l.13.04c.54.19,1.44.34,2,.35h0s7.57.03,7.57.03c-2.18,1.9-11.87,5.59-13.81,5.65-2.6.07-11.37-4.05-13.98-3.78-.58.06-1.18.23-1.72.42-1.02.36-2.14-.19-2.46-1.23L.1,36.8c-.39-1.24.4-2.54,1.67-2.75.57-.1,1.12-.2,1.49-.29Z"
          />
        </g>
        <g id="circle_left">
          <motion.path
            className="cls-2"
            d="M10.92,4.35c.2,1.09-.73,2.03-1.81,1.82-.6-.12-1.09-.61-1.2-1.22-.2-1.09.73-2.03,1.81-1.82.6.12,1.09.61,1.2,1.22Z"
            animate={{ opacity: [1, 0, 1, 1] }}
            transition={{
              ease: "linear",
              times: [0, 0.1, 0.12, 1],
              duration: 1,
              repeat: Infinity,
              delay: 4,
              repeatDelay: 5.5,
            }}
          />
        </g>
        <g id="circle_center">
          <motion.path
            className="cls-1"
            d="M17.06,4.35c.2,1.09-.73,2.03-1.81,1.82-.6-.12-1.09-.61-1.2-1.22-.2-1.09.73-2.03,1.81-1.82.6.12,1.09.61,1.2,1.22Z"
            animate={{ opacity: [1, 0, 1, 1] }}
            transition={{
              ease: "linear",
              times: [0, 0.1, 0.12, 1],
              duration: 1,
              repeat: Infinity,
              delay: 0.4,
              repeatDelay: 5.5,
            }}
          />
        </g>
        <g id="circle_right">
          <path
            className="cls-3"
            d="M23.2,4.35c.2,1.09-.73,2.03-1.81,1.82-.6-.12-1.09-.61-1.2-1.22-.2-1.09.73-2.03,1.81-1.82.6.12,1.09.61,1.2,1.22Z"
          />
        </g>
        <motion.g
          id="line_3"
          animate={{
            opacity: [0, 0, 1, 1, 1, 0, 0],
            rotateY: [90, 90, 0, 0, 0, 90, 90],
            originX: 0,
          }}
          transition={{
            ease: "linear",
            times: [0, 0.22, 0.42, 0.5, 0.68, 0.88, 1],
            duration: 6,
            repeat: Infinity,
            repeatDelay: 0.5,
          }}
        >
          <path
            className="cls-2"
            d="M37.14,27.8H8.66c-.42,0-.77-.34-.77-.77s.34-.77.77-.77h28.48c.42,0,.77.34.77.77s-.34.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="line_2"
          animate={{
            opacity: [0, 0, 1, 1, 1, 0],
            rotateY: [90, 90, 0, 0, 0, 90],
            originX: 0,
          }}
          transition={{
            ease: "linear",
            times: [0, 0.16, 0.36, 0.5, 0.8, 1],
            duration: 6,
            repeat: Infinity,
            repeatDelay: 0.5,
          }}
        >
          <path
            className="cls-2"
            d="M37.14,21.64H8.66c-.42,0-.77-.34-.77-.77s.34-.77.77-.77h28.48c.42,0,.77.34.77.77s-.34.77-.77.77Z"
          />
        </motion.g>
        <motion.g
          id="line_1"
          animate={{
            opacity: [0, 0, 1, 1, 1, 0, 0],
            rotateY: [90, 90, 0, 0, 0, 90, 90],
            originX: 0,
          }}
          transition={{
            ease: "linear",
            times: [0, 0.1, 0.3, 0.5, 0.74, 0.94, 1],
            duration: 6,
            repeat: Infinity,
            repeatDelay: 0.5,
          }}
        >
          <path
            className="cls-2"
            d="M37.14,15.48H8.66c-.42,0-.77-.34-.77-.77s.34-.77.77-.77h28.48c.42,0,.77.34.77.77s-.34.77-.77.77Z"
          />
        </motion.g>
      </svg>
    </span>
  )
}

export default AdministrationIcon
